import { connect } from 'react-refetch';
import 'isomorphic-fetch';

export default Component =>
  connect(props => ({
    postContactForm: data => ({
      postContactFormResponse: {
        url: 'https://auth0-marketing.run.webtask.io/contact-form',
        method: 'POST',
        body: JSON.stringify(data)
      }
    }),
    postExtraData: data => ({
      postExtraDataResponse: {
        url: props.extraDataForPosting.url,
        method: 'POST',
        body: JSON.stringify({
          data: {
            content: data
          }
        })
      }
    })
  }))(Component);



// WEBPACK FOOTER //
// ./src/components/ContactUsForm/connect.js